// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"3cfd6b94","685":"ffbdb846"}[chunkId] + ".chunk.css";
};